import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkedin = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M33.714 4H6.28C5.02 4 4 5.036 4 6.307v27.386C4 34.964 5.021 36 6.279 36h27.435C34.971 36 36 34.964 36 33.693V6.307C36 5.036 34.971 4 33.714 4ZM13.671 31.429H8.93V16.157h4.75V31.43h-.008ZM11.3 14.07a2.751 2.751 0 0 1 0-5.5 2.756 2.756 0 0 1 2.75 2.75 2.747 2.747 0 0 1-2.75 2.75ZM31.45 31.43h-4.743V24c0-1.771-.036-4.05-2.464-4.05-2.472 0-2.85 1.929-2.85 3.921v7.558H16.65V16.157h4.55v2.086h.064c.636-1.2 2.186-2.464 4.493-2.464 4.8 0 5.693 3.164 5.693 7.278v8.372Z" })
});
export default SvgLinkedin;
